import { render, staticRenderFns } from "./BundleDialog.vue?vue&type=template&id=764c3e7f&scoped=true&"
import script from "./BundleDialog.vue?vue&type=script&lang=js&"
export * from "./BundleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c3e7f",
  null
  
)

export default component.exports